import type { PresetListSection, PresetListSectionItem } from '@wix/add-panel-common';
import { symbol as Symbol } from '@wix/santa-editor-symbols';
import React, { FC } from 'react';
import { BIOrigin } from '../../../../../constants/BI';
import { ADD_TO_SITE_TRANSLATION_KEY } from '../../../../../constants/translationKeys';
import { HelpActionInitiator, useActionsDispatcher } from '../../../../ActionsDispatcher';
import { useCurrentCategory } from '../../../../CurrentCategoryProvider';
import { generateTitleKey } from '../../../../utils/media/keyGenerator';
import { useUtils } from '../../../../UtilsProvider';
import { ActionItem } from '../components/ActionItem';
import { useItemData } from '../hooks/useItemData';
import { useHandleMouseEvents } from './hooks/useHandleMouseEvents';
import type { PresetListSectionProps } from './PresetSection.types';

const PresetListItem: FC<{ item: PresetListSectionItem; section: PresetListSection }> = ({ section, item: _item }) => {
  const item = useItemData(_item);

  const { systemId, title, desc, image, symbol, helpId, learnMoreText, structure } = item;

  const category = useCurrentCategory();

  const {
    translate,
    media: { getMediaUrl },
  } = useUtils();

  const { dispatchHelpClick } = useActionsDispatcher();

  const { handleClick } = useHandleMouseEvents({ category, item, section });

  const handleSubLinkClick = () => {
    dispatchHelpClick({
      helpId,
      categoryId: category.id,
      initiator: HelpActionInitiator.ActionSectionItemSubtitle,
      biHelpParams: {
        component: generateTitleKey(title),
        learn_more: true,
        panel_name: BIOrigin.AddPanel,
        origin: BIOrigin.AddPanel,
      },
    });
  };

  return (
    <ActionItem
      key={systemId}
      dataHook={item.id}
      componentType={structure?.componentType}
      title={translate(title)}
      description={translate(desc)}
      illustration={<img src={getMediaUrl(image)} alt="" />}
      actionIcon={<Symbol name={symbol} />}
      tooltipContent={translate(ADD_TO_SITE_TRANSLATION_KEY)}
      subLinkText={translate(learnMoreText)}
      onSubLinkClick={handleSubLinkClick}
      onClick={handleClick}
      shouldTranslate={false}
    />
  );
};

export const PresetListSectionComponent: FC<PresetListSectionProps> = ({ section }) => {
  const { props } = section;
  const { items } = props;

  return (
    <div>
      {items.map((item: PresetListSectionItem) => (
        <PresetListItem key={item.systemId} item={item} section={section} />
      ))}
    </div>
  );
};
